import { Link, type LinkProps } from '@frontend/components';

export type ResponseLinkProps = LinkProps;

/**
 * Base link component for Response.
 * Provides consistent styling for links in AI responses.
 */
export const ResponseLink = ({
  className,
  children,
  ...props
}: ResponseLinkProps) => {
  return (
    <Link
      className={className}
      color="interaction.main"
      _hover={{
        color: 'interaction.hover',
        textDecoration: 'underline',
      }}
      _active={{
        color: 'interaction.active',
        textDecoration: 'underline',
      }}
      _focus={{
        boxShadow: 'focus',
        outline: 'none',
      }}
      {...props}
    >
      {children}
    </Link>
  );
};
